export default {"src":"/_next/static/media/groceries.ef871538.svg","height":77,"width":77,"blurWidth":0,"blurHeight":0};